import Menu from "./Menu";

export default class Page {
	constructor () {


		new Menu();

		window.page = this;

		let elTopMessage = document.getElementById('top_message');
		if ( elTopMessage )
		{
			document.getElementById('btn_close_announcement').addEventListener('click', e => {
				elTopMessage.style.height = elTopMessage.clientHeight + 'px';
				Page.addClass(elTopMessage, 'is-animated');
				setTimeout(() => {
					elTopMessage.style.height = '0px';
				}, 5);
			});
		}

	}

	updatePageTitle (title)
	{
		document.title = title + SITE_TITLE;
	}

	static addClass (el, className) {
		if ( !el.classList.contains(className) )
		{
			el.classList.add(className);
		}
	}

	static removeClass (el, className) {
		if ( el.classList.contains(className) )
		{
			el.classList.remove(className);
		}
	}

	static hasClass (el, className) {
		return el.classList.contains(className);
	}
}